export default __webpack_public_path__ + "static/media/checkmark-blue.215ba839.svg";